// alert(1);
if (!customElements.get("video-banner")) {
  customElements.define(
    "video-banner",
    class ProductForm extends HTMLElement {
      constructor() {
        // alert();
        super();
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.navBuyButton = document.querySelector(
          ".suger-shift-buy-2-button a"
        );
         this.pageBuyButton = document.querySelector(
          ".magazine-hero-banner__button"
        );     
          this.pageBuyButton2 = document.querySelector(
          ".sugar-shift-challenge-btn"
        );
        this.pageBuyButton3 = document.querySelector(
          ".were-different-image-text__button .btn"
        );
        this.pageBuyButton4 = document.querySelector(
          ".magazine-faq__button .btn"
        );
        this.pageBuyButton5 = document.querySelector(
          ".text-button__container .btn"
        );
    
        // this.productBuyButton = document.querySelector(
        //   ".product-image-n-content-wrapper .product-image-n-content-button"
        // );
        
        // console.log(this.pageBuyButton, this.productBuyButton);
        this.navBuyButton.addEventListener(
          w3elem,
          this.onClickHandler.bind(this)
        );
        this.pageBuyButton.addEventListener(
          w3elem,
          this.onClickHandler.bind(this)
        );
        this.pageBuyButton2.addEventListener(
          w3elem,
          this.onClickHandler.bind(this)
        );
        this.pageBuyButton3.addEventListener(
          w3elem,
          this.onClickHandler.bind(this)
        );
        this.pageBuyButton4.addEventListener(
          w3elem,
          this.onClickHandler.bind(this)
        );
        this.pageBuyButton5.addEventListener(
          w3elem,
          this.onClickHandler.bind(this)
        );
   
        // this.productBuyButton.addEventListener(
        //   "click",
        //   this.onClickHandler.bind(this)
        // );
        //   alert(1);
      }

      ajaxAddToCart(config) {
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then((response) => {
            console.log(response);
            this.cart.renderContents(response);
          })
          .catch((error) => {
            console.log("Error:", error);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
          });
      }

      formDataFunction() {
        const productFromData = new FormData();
        // Manually append form data
        productFromData.append("id", 32175461040164);
        productFromData.append("quantity", 3);
        productFromData.append("properties[_fgwes__notapply]", true);
        if (this.cart) {
          productFromData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          productFromData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          productFromData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        return productFromData;
      }

      addProductToCart() {
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        config.body = this.formDataFunction();
        // return false;
        this.ajaxAddToCart(config);
      }

      onClickHandler(evt) {
        // alert(1);
        evt.preventDefault();
        this.addProductToCart(evt);
      }
    }
  );
}
